import { useQuery, useQueryClient } from "@tanstack/react-query";

import { GMN } from "@nens/brostar/openapi-client";

import { getApi } from "@/api/api-configuration";

import { fetchAllPages } from "./helpers/fetch-all-pages";
import { findInListQuery } from "./helpers/find-in-list-query";

const uploadApi = getApi();

// ─── SINGLE ──────────────────────────────────────────────────────────────────

const getGmnSingleQuery = (uuid: string) => ({
  queryKey: ["gmn-single", uuid],
  queryFn: () => uploadApi.apiGmnGmnsRead({ uuid }),
});

export const useGmnSingleQueryDirectly = () => {
  const queryClient = useQueryClient();
  return (uuid: string) =>
    findInListQuery<GMN>(queryClient, ["gmn-list-all"], uuid, getGmnSingleQuery(uuid));
};

// ─── LIST ─────────────────────────────────────────────────────────────────────

const getGmnListAllPagesQuery = () => ({
  queryKey: ["gmn-list-all"],
  queryFn: () => fetchAllPages((pageOptions) => uploadApi.apiGmnGmnsList({ ...pageOptions })),
});

export const useGmnListAllPagesQuery = () => {
  return useQuery(getGmnListAllPagesQuery());
};

// ─── INVALIDATION ─────────────────────────────────────────────────────────────

export const useInvalidateGmnQueries = () => {
  const queryClient = useQueryClient();
  return async () => {
    await queryClient.invalidateQueries({
      queryKey: ["gmn-single"],
      refetchType: "all",
    });
    await queryClient.invalidateQueries({
      queryKey: getGmnListAllPagesQuery().queryKey,
      refetchType: "all",
    });
  };
};
